export const tr = {
  // topnav
  Search: 'Arama',
  FullScreen: 'Tam Ekran',
  Refresh: 'Yenile',
  selected: 'seçili',

  LogIn: 'Oturum Aç',
  LogOut: 'Oturumu Kapat',
  SignUp: 'Kaydol',
  SignIn: 'Giriş Yap',

  // sidenav
  Alerts: 'Uyarılar',
  Heartbeats: 'Kalp Atışları',
  Users: 'Kullanıcılar',
  Groups: 'Gruplar',
  Customers: 'Müşteriler',
  Blackouts: 'Karartmalar',
  Permissions: 'İzinler',
  APIKeys: 'API Anahtarları',
  Labels: 'Etiketler',
  Searches: 'Aramalar',
  Reports: 'Raporlar',
  More: 'Daha Fazla',
  Settings: 'Ayarlar',
  Help: 'Yardım',
  About: 'Hakkında',

  // more
  ChooseDisplayDensity: 'Görüntü yoğunluğu seç',
  DisplayDensity: 'Görüntü yoğunluğu',
  Comfortable: 'Rahat',
  Compact: 'Sıkı',
  Panel: 'Panel',
  Hide: 'Gizle',
  Show: 'Göster',
  DownloadAsCsv: 'CSV olarak indir',

  // Groups store
  UserAddedGroup: 'Kullanıcı gruba eklendi.',
  UserRemovedGroup: 'Kullanıcı gruptan çıkarıldı.',

  // Preferences store
  SettingsSaved: 'Ayarlar kaydedildi.',
  SettingsReset: 'Varsayılan ayarlara dönüldü.',
  SettingsError: 'Kullanıcı tercihleri alınamadı.',

  // Users store
  UserStatusSaved: 'Kullanıcı durumu kaydedildi.',
  EmailSaved: 'E-posta teyidi kaydedildi.',

  // statuses
  Open: 'Aç',
  Assign: 'Ata',
  Ack: 'Teyid',
  Shelved: 'Rafta',
  Blackout: 'Karartma',
  Closed: 'Kapalı',
  Expired: 'Süresi geçmiş',
  Unknown: 'Bilinmeyen',
  NotValid: 'Geçersiz',

  // operator actions
  Open: 'Aç',
  Assign: 'Ata',
  Ack: 'Teyid',
  Unack: 'Teyit kaldır',
  Shelve: 'Rafta',
  Unshelve: 'Raftan kaldır',
  Close: 'Kapat',
  Watch: 'İzle',
  Unwatch: 'İzleme kaldır',
  AddNote: 'Not ekle',
  Delete: 'Sil',

  // Alert actions
  TextIsRequired: 'Metin zorunludur',
  TextMustBeLessThan: 'Metnin azami uzunluğu',
  characters: 'karakterdir',
  // this sentence would not break like this in Turkish. Paraphprased accordinly.

  // Alert detail
  AlertId: 'Uyarı ID',
  AlertOrNoteId: 'Uyarı/Not ID',
  LastReceiveAlertId: 'Son Alınan Uyarı ID',
  CreateTime: 'Oluşturma Zamanı',
  ReceiveTime: 'Alma Zamanı',
  LastReceiveTime: 'Son Alma Zamanı',
  Customer: 'Müşteri',
  Service: 'Servis',
  Environment: 'Ortam',
  Resource: 'Kaynak',
  Event: 'Olay',
  Correlate: 'İlişkilendir',
  Group: 'Grup',
  Severity: 'Şiddet',
  Status: 'Durum',
  Value: 'Değer',
  Text: 'Metin',
  TrendIndication: 'Trend Göstergesi',
  Timeout: 'Zaman aşımı',
  Type: 'Tip',
  DuplicateCount: 'Mükerrer sayısı',
  Repeat: 'Tekrar',
  Origin: 'Köken',
  Tags: 'Taglar',
  Attributes: 'Nitelikler',
  History: 'Tarihçe',
  Data: 'Veri',

  Details: 'Detaylar',
  addedNoteOn: 'Tarihinde not eklendi.',
  by: 'Ekleyen',
  // would be backwards for Turkish (paraphrased)

  // Alert history
  UpdateTime: 'Güncelleme Zamanı',
  Updated: 'Güncellendi',
  User: 'Kullanıcı',

  // Alert list
  Loading: 'Yükleniyor',
  NoDataAvailable: 'Mevcut veri yok',
  ALL: 'HEPSİ',
  Description: 'Tanım',
  Attribute: 'Nitelik',
  TimeoutLeft: 'Zaman Aşımı',
  Dupl: 'Mükerrer',
  PrevSeverity: 'Önceki Şiddet',
  Duration: 'Süre',
  LastReceiveId: 'Son Alınan ID',
  LastNote: 'Son Not',

  // Alert list filter
  Filters: 'Süzgeçler',
  FilterDescription: 'Sonuçları metin arama ile süz',
  AllEnvironments: 'Tüm ortamlar',
  EnvironmentDescription: 'Bir veya daha fazla ortam seç',
  AllSeverities: 'Tüm şiddetler',
  SeverityDescription: 'Bir veya daha fazla şiddet seç',
  AllStatuses: 'Tüm durumlar',
  StatusDescription: 'Bir veya daha fazla durum seç',
  AllCustomers: 'Tüm müşteriler',
  CustomerDescription: 'Bir veya daha fazla müşteri seç',
  AllServices: 'Tüm servisler',
  ServiceDescription: 'Bir veya daha fazla grup seç',
  AllGroups: 'Tüm gruplar',
  GroupDescription: 'Bir veya daha fazla grup seç',

  Latest: 'Son',
  Hour: '1 saat',
  SixHours: '6 saat',
  TwelveHours: '12 saat',
  SelectRange: 'Aralık Seç',

  DateTime: 'Tarih/Saat',
  StartDate: 'Başlangıç Tarihi',
  EndDate: 'Bitiş Tarihi',
  Time: 'Zaman',
  Apply: 'Uygula',
  Reset: 'Sıfırla',

  // API keys
  APIKey: 'API anahtarı',
  Search: 'Arama',
  Customer: 'Müşteri',
  Scopes: 'Kapsam',
  Expires: 'Süresi Geçme Zamanı',
  Active: 'Etkin',
  Expired: 'Süresi Geçmiş',
  Slow: 'Yavaş',

  User: 'Kullanıcı',
  LastUsed: 'Son Kullanma',
  Actions: 'Eylemler',

  Copy: 'Kopyala',
  Copied: 'Kopyalandı!',
  NewApiKey: 'Yeni API Anahtarı',
  EditApiKey: 'Api Anahtarını Düzenle',

  // Blackouts
  ChooseService: 'Bir veya daha fazla servis seç',
  Start: 'Başlangıç',
  End: 'Bitiş',
  Created: 'Oluşturulma',
  Reason: 'Sebep',
  NewBlackout: 'Yeni Karartma',
  EditBlackout: 'Karartma Düzenle',
  Active: 'Etkin',
  Pending: 'Bekleyen',
  Expired: 'Süresi Geçmiş',
  WholeEnvironment: 'Whole Environment',
  AllOrigin: 'All from Origin',

  // Customers
  LookUp: 'Ara',
  LookUpDescription: 'Use login, Keycloak role, GitHub org, GitLab group or email domain',
  NewCustomer: 'Yeni Müşteri',
  EditCustomer: 'Müşteri Düzenle',
  // Groups
  AddRemoveUsers: 'Kullanıcı Ekle/Kaldır',
  Addusers: 'Kullanıcı Ekle',
  UsersInGroup: 'Gruptaki Kullanıcılar',
  NumberUsers: 'Kullanıcı Sayısı',
  NewGroup: 'Yeni Grup',
  EditGroup: 'Grup Düzenle',

  // Heartbeats
  Latency: 'Gecikme',
  Since: 'Başlangıç',
  // Hard to translate

  // Manifest
  API: 'API',
  OpenGitHub: 'GitHub\'da Aç',
  WebUI: 'Web Arayüzü',
  Build: 'Build',
  Date: 'Tarih',
  GitRevision: 'Git Revizyonu',
  APIEndpoint: 'API Endpoint',

  // Perms
  Role: 'Rol',
  Scope: 'Kapsam',
  SystemRole: 'Sistem rolü',
  NewPermission: 'Yeni izin',
  EditPermission: 'İzin düzenle',

  // Preferences
  ApplicationSettings: 'Uygulama Ayarları',
  DarkTheme: 'Koyu Tema',
  PlaySounds: 'Bilgilendirme seslerini aç',
  LanguageSettings: 'Dil Ayarları',
  Languages: 'Diller',
  English: 'İngilizce',
  French: 'Fransızca',
  German: 'Almanca',
  Turkish: 'Türkçe',
  DateTimeSettings: 'Tarih ve Zaman ayarları',
  LongDate: 'Uzun Tarih biçimi',
  MediumDate: 'Orta Tarih biçimi',
  ShortTime: 'Kısa Tarih biçimi',
  DisplayMode: 'Görüntüleme modu',
  UseLocal: 'Yerel tarih ve saat kullan',
  UseUTC: '(UTC) Zamanı kullan',
  AlertSettings: 'Uyarı özet ayarları',
  ShowAllowedEnvs: 'İzin verilen ortamları her zaman göster',
  ShowNotesIcon: 'Notlar ikonunu göster',
  ShowNotesHint: 'Operatör notu olduğunu göstermek için uyarı durumu yanında ikon kullan',
  Font: 'Font',
  FontSize: 'Font Boyu',
  FontWeight: 'Font Ağırlığı',
  PageRows: 'Sayfa başı satır',
  rows: 'satırlar',
  ValueWidth: 'Değer Genişliği',
  DescriptionWidth: 'Tanım Metin Genişliği',
  RefreshInterval: 'Yenileme aralığı',
  seconds: 'saniye',
  minutes: 'dakika',
  AckTimeout: 'Teyid Zaman Aşımı',
  ShelveTimeout: 'Raf Zaman Aşımı',
  BlackoutSettings: 'Karartma dönemi ayarları',
  BlackoutStartNow: 'Karartma dönemlerini hemen başlat',
  BlackoutPeriod: 'Karartma Dönemi',
  hours: 'saat',

  // Profile
  Profile: 'Profil',
  UserID: 'Kullanıcı ID',
  PrimaryUserID: 'Ana Kullanıcı ID',
  Provider: 'Sağlayıcı',
  EmailVerified: 'E-posta teyid edildi',
  EmailNotVerified: 'E-posta teyid edilemedi',
  Customers: 'Müşteriler',
  Organizations: 'Kuruluşlar',
  Groups: 'Gruplar',
  Roles: 'Roller',
  Scopes: 'Kapsamlar',
  others: 'diğer',

  // Status
  LastUpdate: 'Son Güncelleme',
  Uptime: 'Çalışma Süresi',
  Metric: 'Ölçü',
  Type: 'Tip',
  Name: 'İsim',
  Value: 'Değer',
  AvgTime: 'Ort. Süre',

  // Users
  Active: 'Etkin',
  Inactive: 'Atıl',
  Login: 'Giriş',
  Email: 'E-posta',
  Verified: 'Teyidli',
  Comment: 'Yorum',
  VerifiedOrNot: 'Teyidli?',
  LastLogin: 'Son Oturum',
  NewUser: 'Yeni Kullanıcı',
  EditUser: 'Kullanıcı Düzenle',

  // Reports
  Top: 'Top',
  Flapping: 'Flapping',
  Offenders: 'Offenders',
  Standing: 'Standing',
  TopFlappingDescription: 'Chattering and fleeting alert sources that have generated the most number of alert severity changes.',
  TopOffendersDescription: 'Frequently occurring alert sources that have generated the most number of alerts and alert duplicates.',
  TopStandingDescription: 'Stale alert sources that have active alerts for a prolonged duration.',
  
  Count: 'Sayı',
  DuplCount: 'Mükerrer Sayısı',
  Services: 'Servisler',
  Resources: 'Kaynaklar',

  // User Confirm
  Thanks: 'Teşekkürler!',
  YouCanNowLogin1: 'Şimdi',
  YouCanNowLogin2: 'oturum açabilirsiniz.',
  EmailConfirmFailed: 'Üzgünüz, e-posta adresinizi teyit ederken bir hata oluştu.',
  TryAgain: 'Lütfen tekrar deneyin',

  // User Forgot
  ResetLink: 'Girdiğiniz e-posta adresine bir yenileme linki göndereceğiz',
  AlreadyHaveAccount: 'Zaten bir hesabınız var mı?',
  CheckEmail: 'Yenileme linkini e-postanızda bulacaksınız...',
  ReturnSignIn: 'Oturum açmaya geri dön',
  ResetEmailSent: 'Yenileme e-postası başarıyla gönderildi!',

  // User Login
  LoginToContinue: 'Devam etmek için Alerta\'da oturum aç',
  Username: 'Kullanıcı Adı:',
  Password: 'Parola',
  CreateAccount: 'Hesap Oluştur',
  ForgotPassword: 'Parolayı mı unuttunuz?',
  UnspecifiedProblem: 'Üzgünüz, bir sorun oluştu',
  AuthWith: 'Kimlik denetleniyor',
  AuthInProgress: 'Kimlik denetleniyor...',
  AuthNotPossible: 'Üzgünüz, Kimlik denetlemesi yapılamıyor',
  AuthProviderUnknown: 'Bilinmeyen kimlik denetleme sağlayıcı',

  // User Logout
  LoggedOut: 'Oturumunuz sonlandırıldı.',

  // User Reset
  ChooseNewPassword: 'Yeni bir parola seç',
  ConfirmPassword: 'Parolayı teyid et',
  ResetPassword: 'Parolayı Yenile',

  // User Signup
  CreateAlertaAccount: 'Alerta hesabı oluşturun',
  SignUpNotAvailable: 'Üzgünüz, şu anda yeni kayıt alınmıyor',
  FullName: 'Ad Soyad',
  Min6Char: 'En az 6 karakter',
  PasswordNotMatch: 'Girilen Parolalar aynı değil',

  // Labels
  scope: 'kapsam',
  role: 'rol',
  customer: 'müşteri',
  group: 'grup',

  // General
  ConfirmDelete: 'Bu kalemi silmek istediğinizden emin misiniz?',
  Error: 'Hata',
  Send: 'Gönder',
  Required: 'Zorunlu',
  Cancel: 'İptal',
  Save: 'Kaydet',
  NoDisplay: 'Üzgünüz, görüntülenecek bir şey yok :(',
  SearchNoResult1: 'Arama yaptığınız terim ',
  SearchNoResult2: 'için sonuç bulunamadı.',
  // two above paraphrased together to break at the right place. sounds awkward of course
  OK: 'OK',

  // ENDS.
}
